import { render, staticRenderFns } from "./HomeGoToResources.vue?vue&type=template&id=627d8896&scoped=true&"
import script from "./HomeGoToResources.vue?vue&type=script&lang=js&"
export * from "./HomeGoToResources.vue?vue&type=script&lang=js&"
import style0 from "./HomeGoToResources.vue?vue&type=style&index=0&id=627d8896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627d8896",
  null
  
)

export default component.exports